module.exports = __webpack_public_path__ + "static/media/card-link-request-empty.f2a748e2.svg";